import React from "react";
import "./styles.css";

export default function AgentCard({
  name = "Chatbotics Agent",
  role = "AI Assistant",
  avatar = "https://api.dicebear.com/7.x/bottts/svg?seed=Agent",
}) {
  return (
    <div className="agent-card">
      <img src={avatar} alt="Agent avatar" className="agent-avatar" />
      <div className="agent-info">
        <div className="agent-name">{name}</div>
        <div className="agent-role">{role}</div>
      </div>
      <div className="agent-status">● online</div>
    </div>
  );
}
